module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_4_1-b65f38201ac22c30aa31d3bf48e747f9.webp";